var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-toolbar",
        { attrs: { color: "primary", dark: "", flat: "" } },
        [
          _c("v-toolbar-title", { attrs: { "overflow-auto": "" } }, [
            _vm._v(" Deltas "),
          ]),
          _c("v-spacer"),
          _c("DialogForm", {
            attrs: {
              title: "New Delta",
              icon: "add",
              "max-width": "800",
              submit: _vm.addDelta,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function () {
                  return [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { staticClass: "pt-6", attrs: { cols: "2" } },
                          [_vm._v(" Name ")]
                        ),
                        _c(
                          "v-col",
                          { staticClass: "grow" },
                          [
                            _c("v-text-field", {
                              staticClass: "pt-0",
                              attrs: {
                                rules: [_vm.$utils.validation.required],
                              },
                              model: {
                                value: _vm.newDelta.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.newDelta, "name", $$v)
                                },
                                expression: "newDelta.name",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "pt-6",
                            attrs: { cols: "12", sm: "2" },
                          },
                          [_vm._v("Case A")]
                        ),
                        _c(
                          "v-col",
                          [
                            _c("InputSelectCase", {
                              attrs: {
                                rules: [_vm.$utils.validation.required],
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.retrieveJobs(_vm.newDelta.caseA_id)
                                },
                              },
                              model: {
                                value: _vm.newDelta.caseA_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.newDelta, "caseA_id", $$v)
                                },
                                expression: "newDelta.caseA_id",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "pt-6",
                            attrs: { cols: "12", sm: "2" },
                          },
                          [_vm._v("Case B")]
                        ),
                        _c(
                          "v-col",
                          [
                            _c("InputSelectCase", {
                              attrs: {
                                rules: [_vm.$utils.validation.required],
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.retrieveJobs(_vm.newDelta.caseB_id)
                                },
                              },
                              model: {
                                value: _vm.newDelta.caseB_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.newDelta, "caseB_id", $$v)
                                },
                                expression: "newDelta.caseB_id",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c("v-col", [_vm._v(" Calculation Type ")]),
                        _c("v-select", {
                          attrs: {
                            rules: [_vm.$utils.validation.required],
                            items: _vm.modules,
                            "item-text": "name",
                            "item-value": "type",
                            solo: "",
                            label: "Module",
                          },
                          model: {
                            value: _vm.newDelta.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.newDelta, "type", $$v)
                            },
                            expression: "newDelta.type",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c("FeathersServiceTable", {
        attrs: {
          service: "deltas",
          headers: _vm.headers,
          params: _vm.deltasParams,
          "show-expand": "",
          useClonedItems: "",
          dense: "",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "item.name",
              fn: function (ref) {
                var item = ref.item
                return [
                  _c("v-text-field", {
                    attrs: { solo: "", flat: "" },
                    model: {
                      value: item.new.name,
                      callback: function ($$v) {
                        _vm.$set(item.new, "name", $$v)
                      },
                      expression: "item.new.name",
                    },
                  }),
                ]
              },
            },
            {
              key: "item.status",
              fn: function (props) {
                return [
                  props.item.new.error
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        {
                                          staticClass: "pt-4",
                                          attrs: { color: "error" },
                                        },
                                        on
                                      ),
                                      [_vm._v(" error ")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.shortError(props.item.new))),
                          ]),
                        ]
                      )
                    : _c(
                        "v-icon",
                        { staticClass: "pt-4", attrs: { color: "success" } },
                        [_vm._v("check_circle")]
                      ),
                ]
              },
            },
            {
              key: "item.caseA",
              fn: function (props) {
                return [
                  _c("InputSelectCase", {
                    attrs: { "browse-btn-small": "", "disable-url-input": "" },
                    on: {
                      input: function ($event) {
                        return _vm.retrieveJobs(props.item.new.caseA_id)
                      },
                    },
                    model: {
                      value: props.item.new.caseA_id,
                      callback: function ($$v) {
                        _vm.$set(props.item.new, "caseA_id", $$v)
                      },
                      expression: "props.item.new.caseA_id",
                    },
                  }),
                ]
              },
            },
            {
              key: "item.caseB",
              fn: function (props) {
                return [
                  _c("InputSelectCase", {
                    attrs: { "browse-btn-small": "", "disable-url-input": "" },
                    on: {
                      input: function ($event) {
                        return _vm.retrieveJobs(props.item.new.caseB_id)
                      },
                    },
                    model: {
                      value: props.item.new.caseB_id,
                      callback: function ($$v) {
                        _vm.$set(props.item.new, "caseB_id", $$v)
                      },
                      expression: "props.item.new.caseB_id",
                    },
                  }),
                ]
              },
            },
            {
              key: "item.module",
              fn: function (props) {
                return [
                  _c("v-select", {
                    attrs: {
                      items: _vm.modules,
                      "item-text": "name",
                      "item-value": "type",
                      flat: "",
                      solo: "",
                      dense: "",
                      label: "Module",
                    },
                    model: {
                      value: props.item.new.type,
                      callback: function ($$v) {
                        _vm.$set(props.item.new, "type", $$v)
                      },
                      expression: "props.item.new.type",
                    },
                  }),
                ]
              },
            },
            {
              key: "item.actions",
              fn: function (ref) {
                var item = ref.item
                return [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      staticClass: "pt-4",
                                      attrs: {
                                        icon: "",
                                        disabled:
                                          !_vm.itemHasChanged(item.new) ||
                                          !!_vm.isInvalidDelta(item.new),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.saveDelta(item.new)
                                        },
                                      },
                                    },
                                    on
                                  ),
                                  [_c("v-icon", [_vm._v("save")])],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [_c("span", [_vm._v(" Save ")])]
                  ),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      staticClass: "pt-4",
                                      attrs: { icon: "" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.copyDelta(item.new)
                                        },
                                      },
                                    },
                                    on
                                  ),
                                  [_c("v-icon", [_vm._v("content_copy")])],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [_c("span", [_vm._v(" Copy ")])]
                  ),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      staticClass: "pt-4",
                                      attrs: {
                                        icon: "",
                                        disabled: Boolean(item.old.error),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.downloadDelta(item.old)
                                        },
                                      },
                                    },
                                    on
                                  ),
                                  [_c("v-icon", [_vm._v("mdi-download")])],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [_c("span", [_vm._v(" Download results ")])]
                  ),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      staticClass: "pt-4",
                                      attrs: { icon: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeDelta(item.old)
                                        },
                                      },
                                    },
                                    on
                                  ),
                                  [_c("v-icon", [_vm._v("delete")])],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [_c("span", [_vm._v(" Delete ")])]
                  ),
                ]
              },
            },
            {
              key: "expanded-item",
              fn: function (props) {
                return [
                  _c(
                    "td",
                    { attrs: { colspan: _vm.headers.length + 1 } },
                    [
                      props.item.old.delta
                        ? _c("DataTableYearly", {
                            attrs: { items: _vm.deltaItems(props.item.old) },
                          })
                        : [
                            _vm.itemHasChanged(
                              props.item.old,
                              props.item.new
                            ) && !_vm.isInvalidDelta(props.item.new)
                              ? _c("v-alert", { attrs: { color: "success" } }, [
                                  _vm._v("Valid Delta"),
                                ])
                              : _c(
                                  "v-alert",
                                  {
                                    staticClass: "mt-2",
                                    attrs: { type: "error" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.itemHasChanged(
                                          props.item.old,
                                          props.item.new
                                        )
                                          ? _vm.isInvalidDelta(props.item.new)
                                          : props.item.new.error.message
                                      )
                                    ),
                                  ]
                                ),
                          ],
                    ],
                    2
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }